<template>
  <div>
    <div class="login-sign">
      <a class="logo sign" href="#"></a>

      <p style="text-align:center">
        שלום, {{getUser.fullName || 'לומד יקר'}}
        <br />מנהל המערכת עדיין לא אישר את המסלולים שבחרת.
        <br />אנא נסה להיכנס שוב בהמשך.
      </p>
    </div>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  name: "pathsNotRegistered",
  computed: {
    ...mapGetters(["getUser"]),
  },
  // created() {
  //   this.$nextTick(this.checkIfApproved());
  // },
  methods: {
    checkIfApproved() {
      console.log("is it approved?");
      console.log(this.getUser);
      if (this.getUser.userPaths.length > 0 ) this.$router.push({ name: "Paths" });
    },
  },
  watch:{
    getUser(){
      if(this.getUser) this.checkIfApproved();
    }
  }
};
</script>